import React from 'react';

function App() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#111',
      color: '#fff',
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h1 style={{ color: '#ff4444', marginBottom: '20px' }}>Payment Pending</h1>
        <p>This website is currently unavailable due to pending payments.</p>
        <p>Please contact the developer to resolve this issue.</p>
      </div>
    </div>
  );
}

export default App;
